export default { sha: 'a5a28bdf4a91ac7f3fb3954166d4fcadf340cdae', buildNumber: 'undefined' }
